var Base = require('front/components/Base/Base');
var _ = require('underscore');

require('front/components/Header/Header');
require('front/components/Editor/Editor');

require('./About.less');

module.exports = Base.extend({
    el: '.About',

    initialize: function () {
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/About/About.js
// module id = 179
// module chunks = 0